import React, { Component, Suspense, lazy } from 'react';
import { withRouter, Link } from 'react-router-dom';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import GlobalObjetive from './AvailabilityGlobalObjetive/index'
import StepAvailability from './LastAvailabilityStep/index'
import Paper from '@material-ui/core/Paper';
import WarningIcon from '@material-ui/icons/Warning';

import moment from 'moment-timezone'
import 'moment/locale/es'
import Divider from '@material-ui/core/Divider';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ListObjectiveModal from '../../ListObjectiveModal';
import Filter from '../../../../../helpers/Filter'
import NoActiveSection from '../../../../../helpers/NoActiveSection'

import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
// Component styles
import styles from './styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
//const GlobalObjetive = lazy(() => import('../AvailabilityGlobalObjetive'));

import 'moment/locale/es'
moment.locale('es')

class OperativeControl extends Component {

    constructor(props) {        
        super(props);
        this.infoAutoComplete = this.handleState.bind(this);
        var filter="Activos"
        var filterList=[{"nombre":"Activos"},{"nombre":"Downtime"}, {"nombre":"Downtime-Parcial"}, {"nombre":"Uptime"},{"nombre":"Todos"}]
        if(sessionStorage.getItem("filterOperative")!==null){
            filter=sessionStorage.getItem("filterOperative")
            var newFilterList=[{"nombre":filter}]
            filterList.map(ele=>{
                if(ele.nombre!==filter){
                    newFilterList.push(ele)
                }
            })
            filterList=newFilterList
        }
        //console.log(sessionStorage.getItem("filterOperative"), filterList)
        this.state = {
            listObjetives:{},
            listObjetivesData:this.props.params.listObjetivesData,
            isLoading:true,
            token:sessionStorage.getItem('key'),
            user:sessionStorage.getItem("user"),
            dateDowntime:(moment().tz(sessionStorage.getItem('tz')).format("dddd, MMMM YYYY, h:mm:ss a")),
            open: false, 
            objmodal: 0,
            objNameModal: '',
            changeFilter:false,
            filter:filter,
            filterList:filterList,
            intervalId: null,
        }
    }
    
    componentDidMount() {
        this.processData();
        const newInterval = setInterval(() => this.processData(), 300000);
        this.setState({intervalId: newInterval});
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.loadObjectiveData|| !this.state.listObjetivesData|| prevState.changeFilter!== this.state.changeFilter) {   
            //console.log('update')
            this.processData()
        }
        
    }

    processData = () => {
        const { params } = this.props;
        const {filter}=this.state
        const downtimeList = params.listObjetivesData.Downtime
        const partialList = params.listObjetivesData.Partial
        const uptimeList = params.listObjetivesData.Uptime
        const noMonitoringList = params.listObjetivesData.NoMonitoring
        downtimeList.sort(function (a, b) {
            let nombreA = (a.nombre).toLowerCase()
            let nombreB = (b.nombre).toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        partialList.sort(function (a, b) {
            let nombreA = (a.nombre).toLowerCase()
            let nombreB = (b.nombre).toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        uptimeList.sort(function (a, b) {
            let nombreA = (a.nombre).toLowerCase()
            let nombreB = (b.nombre).toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        noMonitoringList.sort(function (a, b) {
            let nombreA = (a.nombre).toLowerCase()
            let nombreB = (b.nombre).toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        })
        sessionStorage.setItem("filterOperative", filter)
        if(filter==="Activos"){
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:downtimeList,
                parcialList:partialList,
                uptimeList:uptimeList,
                noMonitoring:[],
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("dddd, MMMM YYYY, h:mm:ss a"))
            });
        }
        if(filter==="Downtime"){
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:params.listObjetivesData.Downtime,
                parcialList:[],
                uptimeList:[],
                noMonitoring:[],
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("dddd, MMMM YYYY, h:mm:ss a"))
            });
        }
        if(filter==="Downtime-Parcial"){
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:[],
                noMonitoring:[],
                parcialList:partialList,
                uptimeList:[],
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("dddd, MMMM YYYY, h:mm:ss a"))
            });
        }
        if(filter==="Uptime"){
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:[],
                noMonitoring:[],
                parcialList:[],
                uptimeList:uptimeList,
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("dddd, MMMM YYYY, h:mm:ss a"))
            });
        }
        if(filter==="Todos"){
            //console.log("handle", params.listObjetivesData)
            this.setState({
                listObjectives: params.listObjetivesData,
                loadObjectiveData: true,
                downList:downtimeList,
                parcialList:partialList,
                uptimeList:uptimeList,
                noMonitoring:noMonitoringList,
                listObjetivesData:params.listObjetivesData,
                isLoading:false,
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("dddd, MMMM YYYY, h:mm:ss a"))
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    handleOpen = event => {       
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (this.state.open == false){
            this.setState({
                open: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleClose = event => {
        //const newStep = event.currentTarget.id
        this.setState({
            open: false,
            //objmodal: newStep
        })
    };

    getObjetives(obj, type){
        //console.log('getObjetives', obj, type)
        const {open} = this.state    
        const {classes} = this.props    
        let divPaperColor= "#41B900"
        let divIcon=<CheckCircleOutlineIcon style={{width:"22px", height:"22px"}}/>
        let bgColor="#41B900"
        if(type==="down"){
            divPaperColor="#C2272D"
            divIcon=<WarningIcon style={{width:"22px", height:"22px"}}/>
            bgColor="#C2272D"
        }
        if(type==="parcial"){
            divPaperColor="#FFC600"
            divIcon=<ErrorOutlineIcon style={{width:"22px", height:"22px"}}/>
            bgColor="#FFC600"
        }
        if(type==="noMon"){
            divPaperColor="#bdbdbd"
            divIcon=<ErrorOutlineIcon style={{width:"22px", height:"22px"}}/>
            bgColor="#bdbdbd"
        }
        var Availability=<Graph data={obj}/>
        return(
            <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={4}
                xl={3}
                xxl={2}
                spacing={3}           
                style={{padding:"30px"}}
                >
                <Paper style={{ borderColor: divPaperColor, borderTopLeftRadius: 1,borderStyle:'solid'}}>
                    <Button id={obj.objetivo_id} value={obj.nombre} onClick={this.handleOpen}
                            style={{width:"100%",height:"150px", backgroundColor:bgColor}}>
                        <Grid
                            container item
                            direction="column"
                            justify="center"
                            alignItems="center"
                        >      
                        <Grid
                            container item
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >      
                            <Grid item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            xxl={12}
                            className={classes.grid}
                            >
                                <Typography className={classes.objectiveName}>{obj.nombre}</Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            container item
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >      
                            {Availability}
                            
                        </Grid>
                        </Grid>
                    </Button>
                    <GraphStep data={obj.nombre} id={obj.objetivo_id} state={obj.estado}/>
                </Paper>
            </Grid>
        )
               
    }

    handleState=(e,x)=>{
        const {downtime, parcial, uptime}=this.state
        //console.log("x", x)
        var stateObj=  x.nombre
        //console.log("stateObj",stateObj)
        if(stateObj==="Downtime"){
            this.setState({
                parcial:[], 
                uptime:[],
                changeFilter:!this.state.changeFilter, 
                filter:x.nombre
            });
        }else if(stateObj==="Downtime-Parcial"){
            this.setState({
                downtime:[], 
                uptime:[],
                changeFilter:!this.state.changeFilter, 
                filter:x.nombre
            });
        }else if(stateObj==="Uptime"){
            this.setState({
                downtime:[],
                parcial:[],
                changeFilter:!this.state.changeFilter, 
                filter:x.nombre
            })
        }else{
            this.setState({
                changeFilter:!this.state.changeFilter, 
                filter:x.nombre
            });
        }
        
    }

    getObjetivesList(downtime, parcial, uptime, noMon){
        const {filter, filterList}=this.state
        //console.log(filter, noMon)
        var filterGrid=<Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        xxl={12}
                        spacing={3}
                        style={{"paddingBottom":"40px"}}
                    >
                        <Filter list={filterList} label={"Seleccione Estado"} 
                            InfoAutoComplete={this.handleState} placeholder={"Estados"}/>
                    </Grid>
        var dataObjs=<Grid
                        container
                        spacing={10}
                        >
                        {(downtime).map(down => (
                            
                            this.getObjetives(down, "down")
                        ))}
                        {(parcial).map( parcial=> (
                            
                            this.getObjetives(parcial, "parcial")
                        ))}
                        {(uptime).map(uptimeObj => (
                            this.getObjetives(uptimeObj, "uptime")
                        ))}
                        {(noMon).map(noMonObj => (
                            this.getObjetives(noMonObj, "noMon")
                        ))}
                    </Grid>
        if(downtime.length===0 &&parcial.length===0&& uptime.length===0&&noMon.length===0){
            dataObjs=<Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        xxl={12}
                        spacing={3}
                        style={{"paddingBottom":"40px"}}
                    ><Typography variant="h6"> No Existen Objetivos {filter}</Typography></Grid>
        }
        
        return(
            <PortletContent>
                {filterGrid}
                {dataObjs}
            </PortletContent>
        )
               
    }
    
    render() {
        const {  isLoading, listObjetivesData, listObjetives, open, objIdModal, objNameModal } = this.state;
        const { classes } = this.props;

        if (isLoading===true) {
            return(
                <PortletContent>
    
                        <Typography
                          variant="h5"
                        >
                         <CircularProgress
                          variant="indeterminate"
    
                          size={24}
                          thickness={4}
                          
                        />
                        <br/>
                         Cargando Información...
                       </Typography>
                </PortletContent>
            )
        }else if(isLoading===false){
            const {uptimeList, downList, parcialList, listObjetivesData, noMonitoring, listObjetives}=this.state
            //console.log("RENDER", noMonitoring)
                       
            return(
                <div>
                    <div>
                        {this.getObjetivesList(downList,parcialList, uptimeList, noMonitoring)}
                    </div>
                    <div>
                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={open}
                            onClose={this.handleClose}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            closeAfterTransition
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >                                    
                            <Fade in={open}>
                                <PerfectScrollbar style={{position:"static"}}>
                                <div className={classes.div}>                             
                                    <ListObjectiveModal obj={objIdModal} objName={objNameModal} listObjectives={listObjetivesData} handleClose={this.handleClose}/>                        
                                </div>
                                </PerfectScrollbar>
                            </Fade>
                        </Modal>
                    </div>
                </div>
            )
        }
        else return (<p>Error!</p>)
        

    }
}

function Graph(data) {
    return <GlobalObjetive data={data} />

}

function GraphStep(data) {
    //console.log(data)
    //const settings =  {};
    return <StepAvailability data={data}/>

}


export default compose(withRouter, withStyles(styles))(OperativeControl);